import { render, staticRenderFns } from "./addMonedero.vue?vue&type=template&id=67070044"
import script from "./addMonedero.vue?vue&type=script&lang=js"
export * from "./addMonedero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports